import SummaryRow from "./SummaryRow";
import type { SummaryRow as TSummaryRow } from "@/types/types";

type Props = {
  rows: TSummaryRow[] | undefined;
};

export default function Summary({ rows }: Props) {
  return (
    <div
      className={`rounded-md border border-neutral-500 bg-neutral-500 p-8 screen:w-full sm:screen:w-[calc(50%-1rem)]`}
    >
      <span className="text-lg font-medium text-neutral-100">Summary</span>
      <div className="mt-4 rounded-md bg-white p-4 shadow-light">
        <div className={`flex flex-col`}>
          <div className="grid grid-cols-3 gap-x-4 py-4">
            <div className="px-4"></div>
            <div className="relative pl-1 font-medium text-neutral-100 after:absolute after:-top-1 after:left-0 after:h-[calc(100%+1rem)] after:w-[1px] after:-translate-x-[0.625rem] after:bg-neutral-500">
              Current Values
            </div>
            <div className="relative pl-1 font-medium text-neutral-100 after:absolute after:-top-1 after:left-0 after:h-[calc(100%+1rem)] after:w-[1px] after:-translate-x-[0.625rem] after:bg-neutral-500">
              Gross Estate Values
            </div>
          </div>
          {rows?.map((item, i) => {
            return <SummaryRow key={`${item?.name}-${i}`} data={item} />;
          })}
        </div>
      </div>
    </div>
  );
}
